import React, { ReactNode } from "react";
import { Navigate } from 'react-router-dom';

const Pages = React.lazy(() => import("../pages/europe-2024/europe-2024-index"));
const PageNotFound = React.lazy(() => import("../pages/errors/page-not-found"));

export type route = {
  component: ReactNode;
  path: string;
  routes?: route[];
  [propName: string]: any;
};

const Routes: route[] = [
  { path: '/', exact: true, name: 'Europe 2024 Home', component: <Navigate to={`/europe-2024/recap${window.location.search}`} replace /> },
  { path: '/*', exact: true, name: 'Europe 2024 All', component: <Pages /> },

  { path: '/*', exact: true, component: <PageNotFound /> },
]

export default Routes;